export const PageHeadTypes = {
	ROBOTS_NO_INDEX: [{ name: 'robots', content: 'noindex, nofollow' }],
}

export const pageHead = {
	PANEL: {
		PRODUCT_CATALOG: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
		PRODUCT_CATALOG_CARS_ID: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
		PRODUCT_CATALOG_SEGMENT: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
		PARAMETERS: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
		PARAMETERS_ID: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
		LOYALTY_PROGRAMS: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
		DISCOUNT_CODES: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
		DISCOUNT_CODES_ID: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
	},
	AUTH: {
		LOGIN: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
		REGISTER: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
	},
	COMMON: {
		ERROR: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
	},
	RESERVATION: {
		RESERVATION: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
		RESERVATION_COMPLETED: {
			meta: PageHeadTypes.ROBOTS_NO_INDEX,
		},
	},
}
